import type { TFunction } from "i18next";
import { isRequiredStringValid } from "../../../../../mantine/mrt/validation/isRequiredStringValid";
import { validateNumberRangeCounterStartValue } from "../../../../../mantine/mrt/validation/validateCounterStartValue";
import { validateNumberRangeFormat } from "../../../../../mantine/mrt/validation/validateNumberRangeFormat";
import type { PPAInvoiceNumberRangeFormValues } from "../../PPAInvoiceNumberRangesPage.types";
import { isFormatValid } from "./isFormatValid";

/** MRT _valuesCache holds Date objects for valid_from (from accessorFn),
 * not the backend string type. This type reflects the actual cache shape. */
type InvoiceNumberRangeCacheValues = Omit<
  PPAInvoiceNumberRangeFormValues,
  "valid_from"
> & {
  valid_from: Date | null;
};

/** Validates form values from a row in PPAInvoiceNumberRangesTable. */
export function validatePPAInvoiceNumberRangeFormValues(
  range: Partial<InvoiceNumberRangeCacheValues>,
  t: TFunction
) {
  return {
    supplier: !isRequiredStringValid(range.supplier)
      ? t("errors.Required")
      : "",
    format: validateNumberRangeFormat(range.format, isFormatValid, {
      required: t("errors.Required"),
      invalidFormat: t("errors.PPA.InvoiceNumberRanges.formatError")
    }),
    counter_start_offset: validateNumberRangeCounterStartValue(
      range.counter_start_offset === null ||
        typeof range.counter_start_offset === "undefined"
        ? range.counter_start_offset
        : range.counter_start_offset.toString(),
      t
    ),
    valid_from: !(range.valid_from instanceof Date) ? t("errors.Required") : ""
  };
}
